import { IClientSocket, TypedEnumUnion } from './namespaces';

export type ServerEvents = TypedEnumUnion<IClientSocket.ServerEventsValues>;

export const ServerEvents = { ...IClientSocket.ServerEvents };

export default ServerEvents;
